export default __webpack_public_path__ + "img/abx-logo.svg";